import classNames from 'classnames';
import {calculateExpireTime} from 'utilities/helper/expireTime';
interface SaleCardProps {
  title: string;
  image: string;
  createdDate: string;
  price: number;
  soldTime: string;
  wrapperClassName?: string;
}
const SaleCard = ({
  title,
  image,
  createdDate,
  price,
  soldTime,
  wrapperClassName,
}: SaleCardProps) => {
  const {daysRemain, hoursRemain} = calculateExpireTime(soldTime);

  return (
    <>
      <div
        className={classNames(
          'flex bg-white justify-between rounded-lg h-36 mx-2 px-2 py-4  shadow-md w-72 mb-3',
          wrapperClassName,
        )}
      >
        <div className="relative">
          <span className=" absolute top-2 right-1 text-xs text-created-day bg-white py-1 px-2 rounded-3xl">
            {createdDate}
          </span>
          <img
            className="object-cover  rounded-md flex-none w-[120px] h-[103px]"
            src={image}
            alt={title}
            width={120}
            height={103}
          />
        </div>
        <div className="flex flex-col grow p-2 gap-2 h-full">
          <p className="h-[50%] text-black overflow-hidden max-w-[156px] truncate text-sm font-extrabold text-start">
            {title}
          </p>
          <div className="h-[50%] flex flex-col gap-2 justify-center">
            <div className="flex items-center h-[45%]">
              <span className="icon-offsell-card ml-1 text-[20px] text-primary"></span>
              <p className=" text-sm text-gray-6 ">
                {price.toLocaleString()} تومان
              </p>
            </div>
            <div className="flex items-center h-[45%]">
              <span className="icon-clock text-red-1 ml-1 h-full" />
              <p className="font-normal text-sm text-red-1 h-full items-center flex gap-1">
                <span>{daysRemain}روز</span>
                <span>{hoursRemain}ساعت باقی مانده</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SaleCard;
